@if (isSearchableType) {
    <div class="mx-2">
        <kui-input-group [cleanAddons]="true">
            <input kui-input #searchInput type="text" [placeholder]="searchDescription" [(ngModel)]="searchValue" />
            <button kui-button kui-input-group-addon color="secondary">
                @if (!searching) {
                    <kui-icon name="search"></kui-icon>
                }
                @if (searching) {
                    <kui-loader size="small"></kui-loader>
                }
            </button>
        </kui-input-group>
    </div>
}

@if (!!searchNodes?.length) {
    <key-search-results-list
        [list]="searchNodes"
        [highlightValue]="searchValue"
        [maxHeight]="200"
        (onBlur)="blurSearchInput()"
        (onSelected)="
            onSelected({
                id: $event.id,
                name: $event.value,
                eventName: 'activate',
                node: { data: $event.meta },
            })
        "
    ></key-search-results-list>
} @else {
    <kui-tree-select [nodes]="nodes" [selected]="selectedNode" (selectedNodeChanged)="onSelected($event)"></kui-tree-select>
}
